<div class="card h-100">
    <div class="pl-2" style="font-size: 16px">{{title}}</div>
    <div class="pl-2" *ngFor="let sTitle of subTitles">
        {{sTitle}}
    </div>
    <div class="card-body">
        <ul class="list-unstyled form-lr">
            <li class="flex-wrap text-center half">
                <h3 class="score text-center text-primary">SESSIONS</h3>
                <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                        {{sessionData?.total_sessions}}</span></span>
                <span class="form-lr__left fill">Total Sessions</span>
                <ul class="list-unstyled form-lr">
                    <li class="flex-wrap text-center half">
                        <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                                {{sessionData?.first_grade_sessions}}</span></span>
                        <span class="form-lr__left fill">1st Grade</span>
                    </li>
                    <li class="flex-wrap text-center half">
                        <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                                {{sessionData?.sec_grade_sessions}}</span></span>
                        <span class="form-lr__left fill">2nd Grade</span>
                    </li>
                    <li class="flex-wrap text-center half">
                        <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                                {{sessionData?.trd_grade_sessions}}</span></span>
                        <span class="form-lr__left fill">3rd Grade</span>
                    </li>
                </ul>
            </li>
            <li class="flex-wrap text-center half">
                <h3 class="score text-center text-primary">HOURS</h3>
                <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                        {{sessionData?.total_tutor_hours}}</span></span>
                <span class="form-lr__left fill">Total Hours</span>
                <ul class="list-unstyled form-lr">
                    <li class="flex-wrap text-center half">
                        <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                                {{sessionData?.first_grade_session_hours}}</span></span>
                        <span class="form-lr__left fill">1st Grade</span>

                    </li>
                    <li class="flex-wrap text-center half">
                        <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                                {{sessionData?.sec_grade_session_hours}}</span></span>
                        <span class="form-lr__left fill">2nd Grade</span>

                    </li>
                    <li class="flex-wrap text-center half">
                        <span class="form-lr__right fill"><span class="h2 mt-1 d-block mb-0 text-secondary">
                                {{sessionData?.trd_grade_session_hours}}</span></span>
                        <span class="form-lr__left fill">3rd Grade</span>

                    </li>
                </ul>
            </li>
        </ul>
        <ul class="list-unstyled smiley-rating mb-5">
            <li *ngFor="let smiley of smileys" [class.active]="smiley.value === roundedAverage">
                <img alt="smily name" [src]="getImage(smiley)">
            </li>
        </ul>
        <div style="text-align:center">
            <h1 style="font-size:36px"><strong>{{
                    sessionData?.engagement_average ? getEngagementAverage(sessionData?.engagement_average)+' / 5' :
                    'N/A' }} </strong></h1>
            <h3>Average Tutor Engagement</h3>
        </div>
    </div>
</div>